import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { useTranslation } from "react-i18next";
import DataTable from 'react-data-table-component';
import axios from 'axios';
import bag from "../../Assets/Images/profile/defaultProfile.jpg";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import CompLoaderBtn from '../Common/CompLoaderBtn';
import CompLoaderDt from '../Common/CompLoaderDt';
function CompDtMoneyTransfer() {
    const { t } = useTranslation();
    const [componentId] = useState('compDtMoneyTransfer');
    const [data, setData] = useState(null);

    const navigate = useNavigate();

    const [apiCalled, setApiCalled] = useState(false);
    const [apiCalledBy, setApiCalledBy] = useState('');

    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [sort, setSort] = useState('createDate,DESC');
    const [paginationRowsPerPageOptions] = useState([1, 5, 10, 25, 50, 100]);
    const [totalRows, setTotalRows] = useState(0);

    const callMoneyTransferDetails = (moneyTransferData) => {
        setApiCalled(true);
        setApiCalledBy(moneyTransferData?.id);
        let requestBody = {

        };
        const timeout = setTimeout(() => {
            let message = t('product.common-notification.will-be-develop');
            toast.warning(message, { autoClose: 1000 });
            setApiCalled(false);
            let redirectUrl = '/finance/money-transfer/' + moneyTransferData?.id;
            //window.location.href = redirectUrl;
            navigate(redirectUrl);
        }, 500);
    };

    React.useMemo(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            let currentSession = sessionStorage.getItem("currentSession");
            axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
            axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
            let ApiGateway = process.env.REACT_APP_API_URL;
            axios.get(ApiGateway + '/finance/back-office/money-transfer/find-and-list?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&sort=' + sort)
                .then(response => {
                    if (response.data?.isSucceed === true) {
                        setData(response.data?.payload);
                    }

                })
                .catch(error => {
                    console.error(error);
                });
        }
    }, [t, pageNumber, pageSize, sort]);

    const [deleteModal, setDeleteModal] = useState(false);
    const [recordId, setRecordId] = useState(false);

    const onGoToItemDetails = props => {
        //history.push('/product/' + props);
        //dispatch(mpMyCashDeskListApi(props));
    };

    const onBtnDeleteItem = props => {
        let message = 'Prohibited action!';
        toast.error(message, { autoClose: 1000 });
        console.log(props);
        setRecordId(props);
        //setDeleteModal(true);
    };

    const handleDeleteTask = () => {
        if (recordId) {
            //dispatch(mpMyCashDeskDeleteByIdApi({ cashDeskId: recordId }));
            //setDeleteModal(false);
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
        }
    };


    useEffect(() => {
        //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
    }, []);


    const handlePageChange = page => {
        setPageNumber(page - 1);
        //dispatch(mpMyCashDeskListApi(page - 1, pageSize, sort));
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setPageSize(newPerPage);
        //dispatch(mpMyCashDeskListApi(0, newPerPage, sort));
    }

    const columns = [
        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer-list.comp-dt-money-transfer.dt.th.reference-source')}</span>,
            selector: row =>
                <div className="d-flex align-items-center mt-2">
                    <div className="flex-shrink-0 mb-2">
                        <img src={bag} width={28} height={28} alt="" className="avatar-xs rounded-circle" />
                    </div>
                    <div className="flex-grow-1 ms-2">
                        <h6 className="mb-1"><span title={row?.payerCrm?.title}>{row?.payerCrm?.title}</span></h6>
                        <p className="text-muted mb-2"><span title={row?.payerCrm?.segment?.label}>{row?.payerCrm?.segment?.label}</span></p>
                    </div>
                    <div className="flex-shrink-0">
                    </div>
                </div>
            ,
            sortable: false,
            maxWidth: "225px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer-list.comp-dt-money-transfer.dt.th.transaction-type')}</span>,
            selector: row => <span title={row?.transactionType?.label}>{row?.transactionType?.label}</span>,
            sortable: false,
            maxWidth: "135px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer-list.comp-dt-money-transfer.dt.th.money-transfer-type')}</span>,
            selector: row => <span title={row?.moneyTransferType?.label}>{row?.moneyTransferType?.label}</span>,
            sortable: false,
            maxWidth: "185px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer-list.comp-dt-money-transfer.dt.th.reference-source-type')}</span>,
            selector: row => <span title={row?.moneyTransferType?.label}>{row?.referenceSource?.label}</span>,
            sortable: false,
            maxWidth: "135px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer-list.comp-dt-money-transfer.dt.th.reference-id')}</span>,
            selector: row => <span title={row?.moneyTransferType?.label}>{row?.referenceId}</span>,
            sortable: false,
            maxWidth: "285px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer-list.comp-dt-money-transfer.dt.th.create-date')}</span>,
            selector: row => row?.createDate != null ? moment(row?.createDate).format('DD.MM.YYYY HH:mm') : '-',
            sortable: false,
            maxWidth: "185px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.money-transfer-list.comp-dt-money-transfer.dt.th.actions')}</span>,
            selector: row =>
                <>
                    {apiCalled === true && apiCalledBy === row.id ? (
                        <Button onClick={e => callMoneyTransferDetails(row)} className={apiCalled === true ? 'btn btn-dark border-0 border w-100 disabled' : 'btn btn-dark border-0 border w-100'}>
                            <div className={apiCalled === true ? '' : 'd-none'}>
                                <CompLoaderBtn />
                            </div>
                            <span className={apiCalled !== true ? '' : 'd-none'}>{t('components.money-transfer-list.comp-dt-money-transfer.dt.td.button.details')}</span>
                        </Button>
                    ) : (
                        <Button onClick={e => callMoneyTransferDetails(row)} className={apiCalled === true ? 'd-none' : 'btn btn-dark border-0 border w-100'}>
                            <span className={apiCalled !== true ? '' : 'd-none'}>{t('components.money-transfer-list.comp-dt-money-transfer.dt.td.button.details')}</span>
                        </Button>
                    )}
                </>
            ,
            sortable: false,
            maxWidth: "275px"
        },
    ];

    const [pending, setPending] = useState(true);
    const [rows, setRows] = useState([]);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setRows(data?.content);
            setPending(false);
            setTotalRows(data?.page?.totalElements);
        }, 0);
        return () => clearTimeout(timeout);
    }, [data]);

    return (
        <React.Fragment>
            <ToastContainer />
            {data ? ((
                <DataTable
                    id={componentId}
                    columns={columns}
                    data={rows}
                    pagination={true}
                    paginationServer
                    onPageChange={page => setPageNumber(page)}
                    paginationPerPage={pageSize}
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressPending={pending}
                    noDataComponent={t('data-table.label.no-data')}
                    paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                    paginationComponentOptions={{
                        rowsPerPageText: t('data-table.label.rows-per-page'),
                        rangeSeparatorText: t('data-table.label.out-of'),
                    }}
                />
            )) : (
                <Row>
                    <Col className={"col-md-12 text-center"}>
                        <CompLoaderDt />
                    </Col>
                </Row>
            )}
        </React.Fragment>
    );
}
export default CompDtMoneyTransfer;